import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceClientService } from 'src/app/services/service-client.service';
import { environment } from 'src/environments/environment';
import { LogshipStatusResponse } from './logship-status.model';

@Injectable({
  providedIn: 'root',
})
export class LogshipStatusService {
  constructor(private readonly serviceClientService: ServiceClientService) {}

  /**
   * POST /qa_scrubber/logship-status. Super Admin / IOH Admin only, which the Admin Dashboard
   * route already restricts to. An empty body returns every company; `companyId` would narrow
   * it to one, which this view does not need.
   */
  getLogshipStatus(): Observable<LogshipStatusResponse> {
    return this.serviceClientService.post<Record<string, never>, LogshipStatusResponse>(
      environment.endPoints.logshipStatus,
      {},
    );
  }
}
